var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25798_4270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 7.46641L2.60474 1.70992C2.01145 1.46739 1.34119 1.57408 0.855567 1.98823C0.369941 2.40244 0.166828 3.04066 0.325555 3.65378L1.57905 8.49621H7.7163C7.99871 8.49621 8.2277 8.72175 8.2277 8.99999C8.2277 9.27819 7.99874 9.50377 7.7163 9.50377H1.57905L0.325555 14.3462C0.166828 14.9593 0.369907 15.5975 0.855567 16.0117C1.34218 16.4267 2.01251 16.5321 2.60477 16.29L16.6875 10.5336C17.3287 10.2715 17.727 9.68384 17.727 8.99999C17.727 8.31613 17.3287 7.72846 16.6875 7.46641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25798_4270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4545,
    height: 17.4545,
    fill: "white",
    transform: "translate(0.272461 0.272705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.a4140370dd8325f572ae0d7f72b082fb.svg";
export { ForwardRef as ReactComponent };